import React from "react";
import "./whoWeAre.css";
function WhoWeAre() {
  return (
    <section className="whoweare_container">
      <div className="whoweare_image"><img src="/Services.jpeg" alt="people sitting in office" /></div>
      <div className="whoweare_desc">
      <h2>Who We Are</h2>
      <p>
      <span style={{fontSize:"20px", fontWeight:"500"}}>W</span>e are a leading IT staffing and software development company that was established in 2015.
      Our company is committed to providing exceptional services that help businesses achieve their
      goals and succeed in a fast-paced and rapidly changing market.
      </p>
      <div className="know-more-btn-div">
      <a href="./aboutus" target="_blank" rel="noopener noreferrer"><button className="know-btn">Know more</button></a>
      </div>
      </div>
      
    </section>
  );
}

export default WhoWeAre;
